import { Input } from "@nextui-org/react";
import Upload from "components/Upload";
import { useContext } from "react";
import { UserContext } from "utils/context";

const Home = () => {
    const [user] = useContext(UserContext)

    return <div className="page">
        <main>

            <div className="card main form home">
                    <h1 className="gradient" >
                        Déposer un document
                    </h1>
                <Upload users_id={user.id} client={user.role.id !== 1} />
            </div>
        
        </main>

    </div>
}

export default Home;